import { SET_AGENCY } from '../mutation-types'
import AdminApi from '@/api/AdminApi'
import AgencyManagerApi from '@/api/AgencyManagerApi'

import { ability } from '@/permissions/rules'

const getAgency = agencyId => {
  if (ability.can('read', 'AllAgencies')) {
    return AdminApi.getAgency(agencyId)
  } else {
    return AgencyManagerApi.getAgency()
  }
}

const editAgency = agency => {
  if (ability.can('edit', 'AllAgencies')) {
    return AdminApi.editAgency(agency.id, agency)
  } else {
    return AgencyManagerApi.editAgency(agency)
  }
}

const disableAgency = agencyId => {
  return AdminApi.disableAgency(agencyId)
}

const enableAgency = agencyId => {
  return AdminApi.enableAgency(agencyId)
}

const state = {
  currentAgency: null
}

const getters = {
  currentAgency: (state) => state.currentAgency
}

const actions = {

  async getAgency ({ state, commit }, { agencyId, force }) {
    if (!state.currentAgency || force || `${state.currentAgency.id}` !== `${agencyId}`) {
      const agency = await getAgency(agencyId)
      commit(SET_AGENCY, agency)
      return agency
    } else {
      return { agencyId }
    }
  },

  async saveAgency ({ dispatch, commit }, { agency }) {
    const result = await editAgency(agency)
    dispatch('getAgency', { agencyId: agency.id, force: true })
    return result
  },

  async disableAgency ({ dispatch, commit }, { agency }) {
    const result = await disableAgency(agency.id)
    dispatch('getAgency', { agencyId: agency.id, force: true })
    return result
  },

  async enableAgency ({ dispatch, commit }, { agency }) {
    const result = await enableAgency(agency.id)
    dispatch('getAgency', { agencyId: agency.id, force: true })
    return result
  }
}

const mutations = {
  [SET_AGENCY] (state, agency) {
    state.currentAgency = agency
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
